export enum MediaType {
  IMAGE = 'IMAGE',
  SEATMAP = 'SEATMAP',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  STREAMING = 'STREAMING',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/media-type.ts